<script lang="ts">
  import ControlAdminViewFrame from "@kontextwerk/control-web-frame/views/admin"
</script>

<!-- Platform staff see no KB customer data: no cross-organization resets or performance figures. -->
<ControlAdminViewFrame />
